import { enUS as pickersEnUS, ruRU as pickersRuRU } from '@mui/x-date-pickers/locales';

export function getSafePickerLocale(lang: string | null | undefined = 'en') {
  const base =
    lang === 'en'
      ? pickersEnUS.components.MuiLocalizationProvider.defaultProps.localeText
      : pickersRuRU.components.MuiLocalizationProvider.defaultProps.localeText;

  return {
    ...base,
    openDatePickerDialogue: (formattedValue: any, utils?: any) => {
      if (!utils || typeof utils.isValid !== 'function') {
        return formattedValue
          ? `Choose date, selected date is ${formattedValue}`
          : 'Choose date';
      }

      return (base as any).openDatePickerDialogue?.(formattedValue, utils);
    },
  } as any;
}
